import { ethers } from "ethers";
import { handleTx, handleErr, toggleButtons } from "../js/writeContract";

async function approveLpContract() {
  const provider = new ethers.providers.Web3Provider(window.ethereum);
  const signer = provider.getSigner();

  const contract = new ethers.Contract(
    process.env.REACT_APP_LP_ADDRESS,
    process.env.REACT_APP_LP_ABI,
    provider
  );
  const contractWithSigner = contract.connect(signer);

  toggleButtons();

  contractWithSigner
    .approve(
      process.env.REACT_APP_LP_STAKING_ADDRESS,
      "100000000000000000000000"
    )
    .then(async (tx) => {
      handleTx(tx);
    })
    .catch((err) => {
      handleErr(err);
    });
}

async function approveBearContract() {
  const provider = new ethers.providers.Web3Provider(window.ethereum);
  const signer = provider.getSigner();

  const contract = new ethers.Contract(
    process.env.REACT_APP_BEAR_ADDRESS,
    process.env.REACT_APP_BEAR_ABI,
    provider
  );
  const contractWithSigner = contract.connect(signer);

  toggleButtons();

  contractWithSigner
    .setApprovalForAll(process.env.REACT_APP_STAKING_ADDRESS, "true")
    .then(async (tx) => {
      handleTx(tx);
    })
    .catch((err) => {
      handleErr(err);
    });
}

export { approveLpContract, approveBearContract };
